/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { type FC } from 'react';

const Rect = <rect {...{ width: 18, height: 18, rx: 2, ry: 2, x: 1, y: 1 }} />;
const Filled = <polyline {...{ points: '5,9 9,13.5 15,6', fill: 'none', stroke: '#fff', strokeWidth: 1 }} />;

type CheckIconProps = {
  customSvg?: {
    svgProps: {
      width: number;
      height: number;
      viewBox: string;
    };
    forTrue: any;
    forFalse: any;
  };
  labelId: string;
  value: boolean;
  className?: string;
};

const CheckIcon: FC<CheckIconProps> = (props) => {
  const { customSvg, labelId, value, className } = props;
  const svgProps = customSvg ? customSvg.svgProps : { width: 20, height: 20, viewBox: '0 0 20 20' };
  const forTrue = customSvg ? (
    customSvg.forTrue
  ) : (
    <>
      {Rect}
      {Filled}
    </>
  );
  const forFalse = customSvg ? customSvg.forFalse : Rect;

  return <svg {...{ ...svgProps, 'aria-labelledby': labelId, className }}>{value !== true ? forFalse : forTrue}</svg>;
};

export default CheckIcon;
